import React from 'react';
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsCompetitionRulesViewModel} from "../../../../domain/standings/models/competition-rules/standings.competition-rules.view-model";


export class StandingsWidgetCompetitionsRulesContentProps extends BaseProps {
  competitionRules: StandingsCompetitionRulesViewModel
}

export const StandingsWidgetCompetitionsRulesContent = ({competitionRules}: StandingsWidgetCompetitionsRulesContentProps) => {

  return (
    <div className={classNames(styles.competition_rules_content)}>
      <div> {competitionRules.title}</div>
      <ul>
        {
          competitionRules.descriptions?.map((description: String, index: Number) =>
            <li key={index}>{description} </li>)
        }
      </ul>
    </div>)
};